import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Ows from "../../utils/OwsHandler";

export const relationContactRelationSlice = createSlice({
    name: "relationContactRelation",
    initialState: {
        ooid: null,
        relationContactRelation: null,
        loading: false,
        error: null,
    },
    reducers: {
        setRelationContactRelationOoid: (state, action) => {
            state.ooid = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchRelationContactRelation.fulfilled, (state, action) => {
            state.loading = false;
            state.relationContactRelation = action.payload;
        });
        builder.addCase(fetchRelationContactRelation.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        builder.addCase(fetchRelationContactRelation.pending, (state) => {
            state.loading = true;
        });
    },
});

export const fetchRelationContactRelation = createAsyncThunk('relationContactRelation/fetch', async(_, { getState, rejectWithValue }) => {
    const { relationContactRelation: { ooid } } = getState();
    if (!ooid) {
        return rejectWithValue('No ooid found');
    }
    try {
        const { response } = await Ows.handleRequest(
            'Otys.Services.RelationService.getDetail', [
                ooid,
                {
                    "customerNr": 1,
                    "email": 1,
                    "website": 1,
                    "phoneNumberMain": 1,
                    "profileImage": 1,
                    "Addresses": {
                      "address": 1,
                      "city": 1,
                      "postcode": 1,
                      "countryCode": 1,
                      "type": 1,
                      "name": 1,
                      "email": 1,
                      "website": 1,
                      "phoneNumberMain": 1,
                      "phoneNumberFax": 1,
                      "description": 1,
                      "stateId": 1
                    }
                  }              
            ]
        );
        console.log('relationContactRelation response', response);
        return response;
    } catch (error) {
        return rejectWithValue(error);
    }
});

export const { setRelationContactRelationOoid } = relationContactRelationSlice.actions;